import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { RecommendationService } from '../recommendation/recommendation.service';
import { _ } from 'underscore';
import { Router } from '@angular/router';
import { ResidentialService } from '../residential.service';
import { UserSettingsService } from '../../../user-settings/user-settings.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { PlatformLocation } from '@angular/common';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-prepaid-confirmation',
  templateUrl: './prepaid-confirmation.component.html',
  styleUrls: ['./prepaid-confirmation.component.css'],
})
export class PrepaidConfirmationComponent implements OnInit, AfterViewInit {
  selectedProduct;
  t1_avg_charge;
  t2_avg_charge;
  t3_avg_charge;
  avgMthlyUsage;
  averagePrice;
  avgbill;

  // API url
  url = environment.api_url;
  modalRef: BsModalRef;
  @ViewChild('newEnergyRates', { static: true }) newEnergyRates: ElementRef;
  selectedContactNumber: string;
  constructor(
    private recommendationService: RecommendationService,
    private router: Router,
    private residentialService: ResidentialService,
    private userSettingsService: UserSettingsService,
    private http: HttpClient,
    private location: PlatformLocation,
    private modalService: BsModalService
  ) {

    
    if (!_.isEmpty(this.recommendationService.signupProduct)) {
      this.selectedProduct = this.recommendationService.signupProduct;
      sessionStorage.setItem(
        'signupProduct',
        JSON.stringify(this.selectedProduct)
      );
    } else {
      this.selectedProduct = JSON.parse(
        sessionStorage.getItem('signupProduct')
      );
    }
    this.t1_avg_charge = (
      Number(this.selectedProduct.tier[0].avg_charge) * 100
    ).toFixed(1);
    this.t2_avg_charge = (
      Number(this.selectedProduct.tier[1].avg_charge) * 100
    ).toFixed(1);
    this.t3_avg_charge = (
      Number(this.selectedProduct.tier[2].avg_charge) * 100
    ).toFixed(1);
    this.avgMthlyUsage = Math.round(
      this.selectedProduct.new_tier.ave_monthly_usage
    );
    this.averagePrice =
      Number(this.selectedProduct.new_tier.ave_price_per_KWH) * 100;
    this.avgbill = Math.round(this.selectedProduct.new_tier.ave_monthly_bill);
  }

  ngOnInit() {
    this.selectedContactNumber = `tel:${this.selectedProduct.providerContact}`;
    this.location.onPopState(() => {
      history.forward();
      this.back();
    });

   
  }

  ngAfterViewInit(): void {
    $(".startoverclass").hide();
    const avgElements = document.getElementsByClassName('avgvalue');
    for (let i = 0; i < avgElements.length; i++) {
      if (avgElements[i].classList.contains('avgvalue')) {
        if (this.averagePrice.length >= 11 || this.avgbill.length >= 11) {
          avgElements[i].classList.add('avgpricelen32');
        } else if (
          this.averagePrice.length === 10 ||
          this.avgbill.length === 10
        ) {
          avgElements[i].classList.add('avgpricelen37');
        } else if (
          this.averagePrice.length === 9 ||
          this.avgbill.length === 9
        ) {
          avgElements[i].classList.add('avgpricelen42');
        } else if (
          this.averagePrice.length === 8 ||
          this.avgbill.length === 8
        ) {
          avgElements[i].classList.add('avgpricelen46');
        } else if (
          this.averagePrice.length === 7 ||
          this.avgbill.length === 7
        ) {
          avgElements[i].classList.add('avgpricelen50');
        } else if (this.averagePrice.length <= 6 || this.avgbill.length <= 6) {
          avgElements[i].classList.add('mobavgpricelen32');
        }
      }
    }
  }

  back() {
    this.router.navigate([
      'recommendation/compare-product',
      this.recommendationService.hg_accountId,
    ]);
  }
}
